// An info card in the style of the agent page's "What does this Agent Do?" (AboutAgentBanner in
// modules/social-agent/components/social-agent-empty-state.tsx), without its dismiss.

import { Info } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

export function BenchmarkInfo({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <Alert className="max-w-[922px] rounded-2xl border-gray-500 bg-blue-100 p-4 text-blue-500 [&>svg]:size-5">
      <Info aria-hidden="true" />
      <AlertTitle className="text-[14px] font-medium leading-[20px] text-blue-500">{title}</AlertTitle>
      <AlertDescription className="mt-1.5 text-[13px] leading-[18px] text-ink">{children}</AlertDescription>
    </Alert>
  );
}
